import { BREAKPOINT } from "./variable";
import { max, min, larger, medium, smaller } from "./mixin";
export const theme = {
  breakpoints: BREAKPOINT,
  min,
  max,
  larger,
  medium,
  smaller,
};
